var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFighting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62595 1.33018C2.81959 0.565669 3.51218 0 4.33687 0C4.95547 0 5.49975 0.318272 5.81487 0.8H6.3309C6.6515 0.470987 7.0994 0.266667 7.59506 0.266667C8.32175 0.266667 8.94587 0.705881 9.21644 1.33333H9.64847C9.91919 1.16433 10.2391 1.06667 10.5817 1.06667C11.3084 1.06667 11.9325 1.50588 12.2031 2.13333H13.3779C13.388 2.13333 13.3974 2.13604 13.4055 2.14075C13.4591 2.13584 13.5135 2.13333 13.5684 2.13333C14.5431 2.13333 15.3332 2.92348 15.3332 3.89819V9.19019L15.3333 9.2L15.3332 9.20981V9.28603C15.3332 9.31831 15.3323 9.35047 15.3306 9.38247C15.2244 13.0537 11.9233 16 7.86656 16C3.74284 16 0.399902 12.9555 0.399902 9.2C0.399902 7.38722 1.17881 5.74009 2.44845 4.52109C2.44528 6.28838 2.47513 8.11544 2.61274 8.08409C2.98119 8.00009 2.69331 2.52623 2.62595 1.33018Z",
    fill: "#C44D61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFighting);
export default __webpack_public_path__ + "static/media/fighting.fbea4592ddfc88f8f99787676f54c3e0.svg";
export { ForwardRef as ReactComponent };